import { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const KeyboardModeContext = /*#__PURE__*/createContext({
  isKeyboardMode: false
});
export const KeyboardModeProvider = ({
  children
}) => {
  // Indicates if the user is in keyboard mode or mouse mode.
  const [isKeyboardMode, setIsKeyboardMode] = useState(false);
  const value = useMemo(() => ({
    isKeyboardMode
  }), [isKeyboardMode]);

  /**
   * Listens for keyboard and mouse events to determine if the user is in keyboard mode.
   */
  useEffect(() => {
    const containerElement = document.body;
    const activateKeyboardMode = () => {
      setIsKeyboardMode(true);
    };
    const activateMouseMode = () => {
      setIsKeyboardMode(false);
    };
    containerElement.addEventListener('keydown', activateKeyboardMode);
    containerElement.addEventListener('mousemove', activateMouseMode);
    containerElement.addEventListener('mousedown', activateMouseMode);
    containerElement.addEventListener('mouseup', activateMouseMode);
    return () => {
      containerElement.removeEventListener('keydown', activateKeyboardMode);
      containerElement.removeEventListener('mousemove', activateMouseMode);
      containerElement.removeEventListener('mousedown', activateMouseMode);
      containerElement.removeEventListener('mouseup', activateMouseMode);
    };
  }, []);
  return /*#__PURE__*/_jsx(KeyboardModeContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Indicates if the user is in keyboard mode or mouse mode.
 * @returns isKeyboardMode - Boolean indicating if the user is in keyboard mode.
 */
export const useIsKeyboardMode = () => {
  const {
    isKeyboardMode
  } = useContext(KeyboardModeContext);
  return isKeyboardMode;
};